import { useLocation, useHistory } from "react-router-dom";
import { extractReturnUrl, handleGoBack } from "../helpers/TablePageUtils";

/**
 * Результат работы хука useReturnUrl — данные и действие для возврата на предыдущую страницу.
 * @interface UseReturnUrlResult
 * @property {string} returnUrl - Адрес, на который следует вернуться.
 * @property {() => void} handleGoBackTo - Функция-обработчик перехода назад.
 */
export interface UseReturnUrlResult {
    returnUrl: string;
    handleGoBackTo: () => void;
}

/**
 * Хук для извлечения и обработки параметра returnUrl из URL. Используется для навигации "Назад" из карточки записи.
 * @param fallbackUrl — URL, который будет использован, если returnUrl отсутствует или невалиден
 * @returns Объект с returnUrl и функцией handleGoBackTo
 */
export const useReturnUrl = (fallbackUrl: string): UseReturnUrlResult => {
    const location = useLocation();
    const history = useHistory();

    const returnUrl = extractReturnUrl(location, fallbackUrl);

    const handleGoBackTo = () => {
        handleGoBack(history, returnUrl, fallbackUrl);
    };

    return { returnUrl, handleGoBackTo };
};